import { useMemo } from "react";
import {
  modelFitGaps,
  type Exercise,
  type ModelFitGaps,
  type Program,
} from "@heraion/shared";

import { pairCache } from "./pairCache";
import { useProgramSimulation } from "./useProgramSimulation";

// #540: the program's fit (modelFitGaps) computed ONCE per (program, catalog),
// shared by the card (button state) and the preview (the cycle's gaps line).
const fitOf = pairCache<Program, ReadonlyArray<Exercise>, ModelFitGaps>();

/** Null: no catalog yet. */
export function useProgramPlanFit(
  program: Program,
  catalog: ReadonlyArray<Exercise> | null,
): ModelFitGaps | null {
  const sim = useProgramSimulation(program, catalog);
  return useMemo(() => {
    if (!sim || !catalog) return null;
    return fitOf(program, catalog, () => modelFitGaps(sim, catalog));
  }, [program, sim, catalog]);
}
